import { Cfar } from "redmond/build/hotels-module";
import { getTotalPriceText } from "halifax";

export const REVIEWS = "Reviews";
export const getCfarSecondaryText = (cfarCancellation: Cfar) =>
  `Refund amount: ${getTotalPriceText({
    price: cfarCancellation.refundAmount.fiat,
  })}`;
